import React from "react";
import ReactDOM from "react-dom/client"; // Importa desde 'react-dom/client'
import "./index.scss"; // Importa los estilos globales
import "font-awesome/css/font-awesome.min.css"; // Importa los iconos de Font Awesome
import App from "./App"; // Componente raíz de la aplicación
import * as serviceWorkerRegistration from "./serviceWorker"; // Importa el servicio worker
import "./i18n"; // Configuración de i18next para la internacionalización

// Crea la raíz de la aplicación y renderiza el componente raíz <App />
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registra el service worker para habilitar la funcionalidad de PWA
const shouldRegisterServiceWorker = true; // Cambia a true si deseas habilitar el registro

if (shouldRegisterServiceWorker) {
  serviceWorkerRegistration.register({
    onUpdate: () => {
      console.log("Nuevo contenido disponible; recargando...");
      window.location.reload();
    },
    onSuccess: () => {
      console.log("Aplicación cargada desde el caché.");
    },
  });
} else {
  serviceWorkerRegistration.unregister();
}
